import {gql} from "@apollo/client";

export default gql`
  mutation disableManager($managerId: ID!, $employerId: ID!, $reason: String!) {
    disableManager(managerId: $managerId, employerId: $employerId, reason: $reason)
  }
`;
